import {amenitiesFilter, capacitiesFilter} from "./capacities";

export const AllFilters = [capacitiesFilter, amenitiesFilter]
